import { SizableText } from '@my/ui'
import { SignUpButton } from 'app/features/auth/SignUpButton/SignUpButton'
import { useUser } from 'app/utils/useUser'
import { Link } from 'solito/link'

import { UserMenu } from './components/UserMenu'

export const HomeLayout = ({ children }: { children?: React.ReactNode }) => {
  const { isLogin } = useUser()
  return (
    <>
      <section>
        <div className="flex items-center w-full justify-between px-24 py-4 gap-7">
          <Link href="/">
            <SizableText size="$7" fow="bold">
              MOGGAI
            </SizableText>
          </Link>
          {/* {!isLogin && <SignUpButton />} */}
          {isLogin && <UserMenu />}
        </div>
      </section>
      <main className="">{children}</main>
    </>
  )
}
